
<template>
  <div class="loading-cell">
    <v-progress-circular indeterminate />
    <span>{{ params.loadingMessage }}</span>
  </div>
</template>

<script>
export default {
  name: 'cell-loading'
}
</script>

<style lang="scss" scoped>
  .loading-cell {
    padding: 10px;

    span {
      padding-left: 10px;
    }
  }
</style>
